import { Globe } from "lucide-react";
import { useTranslation } from "react-i18next";

interface LanguageSwitcherProps {
  isScrolled?: boolean; // optional, for navbar styling
}

const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({ isScrolled }) => {
  const { i18n } = useTranslation();

  const toggleLang = () => {
    const newLang = i18n.language === "en" ? "ar" : "en";
    i18n.changeLanguage(newLang);
    localStorage.setItem("lang", newLang); // persistence
  };

  return (
    <button
      onClick={toggleLang}
      className={`flex items-center space-x-1 px-3 py-2 ${
  isScrolled
    ? "text-slate-500 hover:text-amber-600"
    : "text-white hover:text-amber-600"
} text-sm font-medium hover:bg-black rounded-lg transition-all duration-200`}>
      <Globe className="w-4 h-4" />
      {i18n.language === 'en' ? 'العربية' : 'English'}
    </button>
  );
};

export default LanguageSwitcher;
